import React from 'react';
import styled from 'styled-components';

import nationality_guide from '@/assets/refund/nationality_guide.png';
type Props = {
  onClose: () => void;
};

function NationalityGuideModal({ onClose }: Props) {
  return (
    <Container onClick={onClose}>
      <Modal onClick={(e) => e.stopPropagation()}>
        <ModalTitle>국적 입력 가이드</ModalTitle>
        <Description>
          고객님의 여권을 확인 후 가이드에 맞게{' '}
          <HighlightText>영문 국적코드 세자리</HighlightText>를 입력해주세요.
        </Description>

        <PassportImageContainer>
          <PassportImage src={nationality_guide} alt='' />
        </PassportImageContainer>

        <BtnContainer>
          <ConfirmBtn onClick={onClose}>확인</ConfirmBtn>
        </BtnContainer>
      </Modal>
    </Container>
  );
}

export default NationalityGuideModal;

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 200;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Modal = styled.div`
  padding: 24px 40px;
  display: flex;
  flex-direction: column;
  background-color: white;
  border-radius: 16px;
`;

const ModalTitle = styled.h3`
  color: var(--Mono-80, #3a3b3e);
  text-align: center;
  /* WebHead/21_BD */
  font-family: Pretendard;
  font-size: 21px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 31.5px */
  letter-spacing: -0.42px;
  margin-bottom: 8px;
`;

const Description = styled.p`
  margin-bottom: 24px;

  color: var(--Mono-65, #5f6165);
  text-align: center;

  /* WebBody/16_MD */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 24px */
  letter-spacing: -0.32px;
`;

const HighlightText = styled.span`
  color: #ed0828;
  font-weight: 600;
`;

const PassportImageContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 24px;

  border-radius: 12px;
`;

const PassportImage = styled.img`
  width: 640px;
  height: 438px;
  user-select: none;
  pointer-events: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
`;

const BtnContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const ConfirmBtn = styled.button`
  display: flex;
  width: 240px;
  height: 42px;
  padding: 9px 0;
  justify-content: center;
  align-items: center;
  background-color: #246cf6;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }
`;
